var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14.2643 3.73642L3.73535 14.2653M14.2643 14.2638L3.73535 3.73486","stroke":"currentColor","stroke-width":"1.85072","stroke-linecap":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }